import React from "react";
import { useParams } from "react-router-dom";
import ReceiptHeader from "./ReceiptHeader";
import { axiosget } from "../../helpers/httprequest";
import Loader from "../../components/Loader";
import is_null from "../../helpers/is_null";
import is_money from "../../helpers/is_money";
import { useQuery } from "@tanstack/react-query";
import ErrorResponse from "../../components/ErrorResponse";
import "./Receipt.css"; // New CSS file for receipt styling

const PaymentReceipt = () => {
  const { id } = useParams();
  const { data, isLoading, error } = useQuery({
    queryKey: ["myReceipt"],
    queryFn: async () => {
      const req = await axiosget(`ms_transactions/${id}`);
      return req?.data;
    },
  });

  const fullAmount = !is_null(data)
    ? data?.find?.items?.reduce((acc, obj) => acc + obj.amount, 0)
    : 0;
  
  let allAmount = fullAmount;
  if (data?.scholar) {
    const percent = Number.parseFloat(data?.scholar?.percentage) / 100;
    allAmount = allAmount * percent;
  }

  if (isLoading) return <Loader />;
  if (error) return <ErrorResponse type="danger" message={`Local server error: ${error}`} />;
  if (data?.type !== undefined) return <ErrorResponse type="danger" message={data?.message} />;
  if (is_null(data)) return <div>No payment information found.</div>;

  return (
    <div className="receipt-container">
      <ReceiptHeader office="Office of the Bursar" subs="Payment receipts" />
      
      <div className="receipt">
        {/* Receipt Header */}
        <div className="receipt-header">
          <h2>OFFICIAL PAYMENT RECEIPT</h2>
          <div className="receipt-meta">
            <span>Receipt No: {data?.find?.rrr || 'N/A'}</span>
            <span>Date: {new Date(data?.find?.createdAt).toLocaleDateString()}</span>
          </div>
        </div>

        {/* Student Information */}
        <div className="receipt-section">
          <div className="student-info">
            <div className="info-column">
              <div className="info-row">
                <span className="info-label">Reg. Number:</span>
                <span className="info-value">{data?.find?.student?.studentid}</span>
              </div>
              <div className="info-row">
                <span className="info-label">Full Name:</span>
                <span className="info-value">
                  {data?.find?.student?.firstname} {data?.find?.student?.middlename} {data?.find?.student?.lastname}
                </span>
              </div>
              <div className="info-row">
                <span className="info-label">School:</span>
                <span className="info-value">
                  {data?.find?.student?.programme?.department?.college?.name}
                </span>
              </div>
            </div>
            <div className="info-column">
              <div className="info-row">
                <span className="info-label">Department:</span>
                <span className="info-value">
                  {data?.find?.student?.programme?.department?.name}
                </span>
              </div>
              <div className="info-row">
                <span className="info-label">Programme:</span>
                <span className="info-value">
                  {data?.find?.student?.programme?.name}
                </span>
              </div>
              <div className="info-row">
                <span className="info-label">Session:</span>
                <span className="info-value">{data?.find?.session?.name}</span>
              </div>
            </div>
          </div>
        </div>

        {/* Payment Details */}
        <div className="receipt-section">
          <h3 className="section-title">
            {data?.session?.name}  STUDENT PAYMENT DETAILS
          </h3>
          <table className="receipt-table">
            <thead>
              <tr>
                <th>SN</th>
                <th>Item Description</th>
                <th>Amount (₦)</th>
              </tr>
            </thead>
            <tbody>
              {data?.find?.items?.map((r, i) => (
                <tr key={r._id}>
                  <td>{i + 1}</td>
                  <td>{r.label}</td>
                  <td className="text-right">{is_money(r.amount)}</td>
                </tr>
              ))}
              {data?.scholar && (
                <>
                  <tr className="subtotal-row">
                    <td>{data?.find?.items?.length + 1}</td>
                    <td>Expected Amount</td>
                    <td className="text-right">{is_money(fullAmount)}</td>
                  </tr>
                  <tr className="discount-row">
                    <td>{data?.find?.items?.length + 2}</td>
                    <td>Discount/Scholarship ({data?.scholar?.percentage}%)</td>
                    <td className="text-right">-{is_money(allAmount)}</td>
                  </tr>
                </>
              )}
            </tbody>
            <tfoot>
              <tr className="total-row">
                <td colSpan="2">TOTAL AMOUNT PAID</td>
                <td className="text-right">{is_money(fullAmount - allAmount)}</td>
              </tr>
            </tfoot>
          </table>
        </div>

        {/* Payment Confirmation */}
        <div className="receipt-section payment-confirmation">
          <p>
            The sum of <strong>{is_money(fullAmount - allAmount)}</strong> was paid to Kebbi State Polytechnic Dakingari, Kebbi State in respect of {data?.find?.session?.name}  Full-Time Registration service via Remita Using RRR: {data?.find?.rrr}
          </p>
          <p className="notice">ALL FEES ARE NON-REFUNDABLE AFTER PAYMENT</p>
        </div>

        {/* Signatures */}
        <div className="signature-section">
          <div className="signature-block">
            <div className="signature-title">ATTESTATION/DECLARATION</div>
            <div className="signature-line"></div>
            <div className="signature-name">
              {data?.find?.student?.firstname} {data?.find?.student?.middlename} {data?.find?.student?.lastname} ({data?.find?.student?.studentid})
            </div>
          </div>
          
          <div className="signature-block">
            <div className="signature-title">CERTIFICATION BY THE BURSAR</div>
            <div className="signature-line"></div>
            <div className="signature-name">HEAD OF BURSARY DEPARTMENT</div>
          </div>
        </div>

        {/* Print Footer */}
        <div className="print-footer">
          This is a computer generated receipt and does require a physical signature
        </div>
      </div>
    </div>
  );
};

export default PaymentReceipt;